import { Note } from "@/components/ui/Note";
import { type Rename, oldNameWords, oldNamesIn } from "@/lib/old-names";
import { cn } from "@/lib/utils";

/**
 * The old names a figure's words still use, one note each. Read only: the
 * words are changed on Define, where Replace is offered.
 */
export function OldNameNotes({
  text,
  renames,
  className,
}: {
  text: string;
  renames: Rename[];
  className?: string;
}) {
  return oldNamesIn(text, renames).map((rename) => (
    <Note key={rename.old} tone="warning" className={cn("mt-1.5", className)}>
      {oldNameWords(rename)}
    </Note>
  ));
}
